import { useCallback, useState } from "react"
import { useDispatch } from "react-redux"

import { resetBorrowFlow } from "#/redux-state"
import { useUpdateBorrowedAmountTransaction } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"
import { ComponentStepProps, StepperModal } from "#/ui/Modal"

import UpdateBalance from "./UpdateBalance"
import UpdateReview from "./UpdateReview"
import UpdateStrategy from "./UpdateStrategy"
import UpdateTransaction from "./UpdateTransaction"

export default function UpdateBorrowModal({
  onClose,
  ...props
}: MezoModalProps) {
  const dispatch = useDispatch()

  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false)

  const handleClose = useCallback(() => {
    dispatch(resetBorrowFlow())
    onClose()
  }, [dispatch, onClose])

  const { borrowMoreHandler, hasError, isLoading } =
    useUpdateBorrowedAmountTransaction()

  return (
    <StepperModal
      {...props}
      variant="tall"
      onClose={handleClose}
      steps={[
        {
          title: "Increase your MUSD balance",
          withCloseButton: true,
          component: UpdateBalance,
        },
        {
          title: "Select strategy",
          withCloseButton: true,
          component: UpdateStrategy,
        },
        {
          title: "Review borrow",
          withCloseButton: true,
          component: (stepProps: ComponentStepProps) => (
            <UpdateReview
              {...stepProps}
              handleBorrowMore={borrowMoreHandler}
              hasAcceptedTerms={hasAcceptedTerms}
              setHasAcceptedTerms={setHasAcceptedTerms}
            />
          ),
        },
        {
          title:
            !hasError && !isLoading ? "Successfully borrowed" : "Updating loan",
          withCloseButton: !hasError && !isLoading,
          withBackButton: hasError,
          component: (stepProps: ComponentStepProps) => (
            <UpdateTransaction
              {...stepProps}
              hasError={hasError}
              isLoading={isLoading}
            />
          ),
        },
      ]}
    />
  )
}
